<script>
// Iconsax Bold `card` — cartão. Faixa superior é a mesma do `card-tick`; o corpo é o
// cartão inteiro (sem o círculo de check). Primeiro uso: card "Total pago" do painel de
// uso de créditos (`ai-framework/components/creditos-uso-painel`).
export default {
  name: 'IconCard',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 7.55039V8.00039C22 8.55039 21.55 9.00039 21 9.00039H3C2.45 9.00039 2 8.55039 2 8.00039V7.54039C2 5.25039 3.85 3.40039 6.14 3.40039H17.85C20.14 3.40039 22 5.26039 22 7.55039Z"
      :fill="color"
    />
    <path
      d="M2 11.5002V16.4602C2 18.7502 3.85 20.6002 6.14 20.6002H17.85C20.14 20.6002 22 18.7402 22 16.4502V11.5002C22 10.9502 21.55 10.5002 21 10.5002H3C2.45 10.5002 2 10.9502 2 11.5002ZM8 17.2502H6C5.59 17.2502 5.25 16.9102 5.25 16.5002C5.25 16.0902 5.59 15.7502 6 15.7502H8C8.41 15.7502 8.75 16.0902 8.75 16.5002C8.75 16.9102 8.41 17.2502 8 17.2502ZM14.5 17.2502H10.5C10.09 17.2502 9.75 16.9102 9.75 16.5002C9.75 16.0902 10.09 15.7502 10.5 15.7502H14.5C14.91 15.7502 15.25 16.0902 15.25 16.5002C15.25 16.9102 14.91 17.2502 14.5 17.2502Z"
      :fill="color"
    />
  </svg>
</template>
